module.exports = __webpack_public_path__ + "img/20250626.98858217.jpg";